import type { CMSAssetDashboardVerification } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { CMS_API_ROOT_URL } from '../constants';

export const CMS_ASSET_DASHBOARD_VERIFICATION_QUERY_KEY = 'cmsAssetDashboardVerificationQueryKey';

const getDashboardVerification = (): Promise<CMSAssetDashboardVerification[]> => {
  const url = `${CMS_API_ROOT_URL}/unverified_assets`;
  return FetchPromise.get(url);
};

export const useGetDashboardVerification = () =>
  useQuery<CMSAssetDashboardVerification[], JQuery.jqXHR>({
    queryKey: [CMS_ASSET_DASHBOARD_VERIFICATION_QUERY_KEY],
    queryFn: () => getDashboardVerification(),
  });
